export enum ASSIGNED_STATUS {
  NEW,
  READING,
  COMPLETED,
}

export enum ASSIGNED_TYPE {
  USER,
  GROUP,
}
